var s="persist:",r="persist/FLUSH",e="persist/REHYDRATE",p="persist/PAUSE",t="persist/PERSIST",i="persist/PURGE",E=-1;export{E as DEFAULT_VERSION,r as FLUSH,s as KEY_PREFIX,p as PAUSE,t as PERSIST,i as PURGE,e as REHYDRATE};
//# sourceMappingURL=constants.js.map
